import React from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import { type PickableRecord } from '../types/PickableRecord';
import RecordPickerController from '../controllers/RecordPickerController';
import RecordIcon from 'components/common/RecordIcon';

export const NAME_WIDTH = 300;
export const WORKSPACE_WIDTH = 125;

interface SearchResultRowProps {
  result: PickableRecord;
}

const SearchResultRow: React.FC<SearchResultRowProps> = ({ result }) => {
  const controller = useController(RecordPickerController);
  const { searchable } = result;

  const referenceNum =
    searchable && 'referenceNum' in searchable && searchable.referenceNum;

  const workflowStatus =
    searchable && 'workflowStatus' in searchable && searchable.workflowStatus;

  return (
    <tr
      className='tw-group'
      onClick={() => controller.actionAddRecordToSelection(result)}
    >
      <td>
        <aha-button
          class='tw-invisible group-hover:tw-visible'
          size='mini'
          onClick={() => controller.actionAddRecordToSelection(result)}
        >
          <i className='fa-regular fa-plus' />
        </aha-button>
      </td>
      <td>{searchable && <RecordIcon record={searchable} />}</td>
      <td>{referenceNum}</td>
      <td>
        <div className='tw-truncate' style={{ maxWidth: NAME_WIDTH }}>
          {result.name}
        </div>
      </td>
      <td>
        <div className='tw-truncate' style={{ maxWidth: WORKSPACE_WIDTH }}>
          {result.project?.name}
        </div>
      </td>
      <td className='tw-text-right'>
        {workflowStatus && (
          <aha-pill
            class='tw-whitespace-nowrap'
            color={`color-mix(in oklch, ${workflowStatus.colorObject.hex()}, var(--theme-primary-background) 60%)`}
          >
            {workflowStatus.name}
          </aha-pill>
        )}
      </td>
    </tr>
  );
};

export default ApplicationView(SearchResultRow);
